import { render, staticRenderFns } from "./digicon-player.vue?vue&type=template&id=d2fa8b3a&scoped=true&"
import script from "./digicon-player.vue?vue&type=script&lang=js&"
export * from "./digicon-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fa8b3a",
  null
  
)

export default component.exports